import React from "react";

import Grid from "@material-ui/core/Grid";

import CellActivities from "../../Cell/Activities";
import LoadingCells from "../../Layout/LoadingLayouts/LoadingCells";
import LoadingScreen from "../../Layout/LoadingScreen";
import SEO from "../../Seo";

import IntlMessage from "../../../LocaleEngine";

import { getSystemSettings } from "../../../utils/SettingsRetriever";

export default function ListGroup(props) {
  const { showImages = true } = props;
  const systemSettings = getSystemSettings();
  const isNotTierLoading =
    systemSettings.app &&
    systemSettings.app.animationMobile &&
    systemSettings.app.animationMobile.type &&
    systemSettings.app.animationMobile.type !== "tier";

  const addToCart = (element, amount, callback) => {
    props.addToCart(element, amount, callback);
  };

  if (props.loadingSearch) {
    if (window.innerWidth < 992 && !isNotTierLoading)
      return (
        <>
          <SEO title="Loading..." />
          <LoadingCells quantity={5} noMargin />
        </>
      );
    return <LoadingScreen />;
  }

  if (!props.list || (props.list && props.list.length <= 0)) {
    return (
      <span className="error">
        <IntlMessage id="activities.list.groups.no_products_available" />
      </span>
    );
  }
  return (
    <Grid
      container
      spacing={0}
      className={props.open !== null ? "groups closed" : "groups"}
    >
      {Array.isArray(props.list) ? (
        props.list.map((element, index) => {
          return (
            <CellActivities
              packageCart={props.packageCart}
              addQuantity={props.addQuantity}
              reduceQuantity={props.reduceQuantity}
              quantityPicker={props.quantityPicker}
              loadingCart={props.loadingCart}
              bundleStatus={props.bundleStatus}
              minQuantity={props.minQuantity}
              maxQuantity={props.maxQuantity}
              dateOfActivity={props.dateOfActivity}
              showUnspanned={props.showUnspanned}
              displayType={props.displayType}
              isPackage={props.isPackage}
              open={props.open}
              toggleSupplier={props.toggleSupplier.bind(this)}
              configuration={props.configuration}
              showImages={showImages}
              addToCart={addToCart.bind(this)}
              key={index}
              index={index}
              element={element}
            />
          );
        })
      ) : (
        <CellActivities
          packageCart={props.packageCart}
          addQuantity={props.addQuantity}
          reduceQuantity={props.reduceQuantity}
          quantityPicker={props.quantityPicker}
          minQuantity={props.minQuantity}
          maxQuantity={props.maxQuantity}
          dateOfActivity={props.dateOfActivity}
          showUnspanned={props.showUnspanned}
          displayType={props.displayType}
          isPackage={props.isPackage}
          open={props.open}
          toggleSupplier={props.toggleSupplier.bind(this)}
          configuration={props.configuration}
          showImages={showImages}
          addToCart={addToCart.bind(this)}
          element={props.list}
        />
      )}
    </Grid>
  );
}
